export const my_portal_toolbar = {
  filter_all: "All",
  filter_active: "Active",
  filter_sold: "Sold",
  filter_removed: "Removed",
  filter_purchased: "Purchased",
  search_placeholder: "Search part number, type, manufacturer…",
};
